export default "__VITE_PUBLIC_ASSET__57c87017__"